module.exports = __webpack_public_path__ + "static/media/header-logo.b94d819c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/header-logo.png
// module id = 519
// module chunks = 0